module.exports = __webpack_public_path__ + "static/media/Greenland_Escape_2026_Logo.pdf.97f153f4.png";